<template>
  <div id="app">
    <Tabbar/>
    <router-view />
    <div class="returnTop" @click="returnTop">
      <img src="./assets/top-icon1.png" />
    </div>
    <footerNav />
    <!-- <div class="bubble-container">
      <div class="bubble"></div>
    </div> -->
    <!-- <img src="./components/lazyLoad.vue"/> -->
  </div>
</template>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    background-color: #ffffff;
  }
  body {
    margin: 0px;
    overflow-x: hidden;
    /* 隐藏水平滚动条 */
    overflow-y: scroll;
    scroll-behavior: smooth;
    /* 显示垂直滚动条 */
  }

  .root {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }


  img {
    width: 100%;
    height: 100%;
  }

  .returnTop {
    position: fixed;
    bottom: 5vw;
    right: 2vw;
    width: 2vw;
    height: 2vw;
    cursor: pointer;
    z-index: 9;
  }

  .mouseCursor {
    cursor: pointer;
  }


</style>
<script>
  import LazyImage from './components/lazyLoad.vue'
  import Tabbar from './components/tabbar.vue'
  import footerNav from './components/footer.vue'
  import router from '@/router'; // 确保路径正确
  export default {
    components: {
      Tabbar,
      footerNav,
      LazyImage
    },
    name: 'App',
    data() {
      return {
        scrolled: false,
        backColor: true,
      }
    },
    created() {
      // 使用全局前置守卫
      router.beforeEach((to, from, next) => {
        this.returnTop(); // 每次路由切换时调用toTop方法
        next();
      });
    },
   
    methods: {
      returnTop() {
        window.scrollTo({
          top: 0, // 滚动到页面顶部
          behavior: 'smooth' // 平滑滚动
        });
      },

    }
  }
</script>